import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ISalesInvoiceStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ISalesInvoiceStatsResponse>,
  IPathBaseParam,
  // TODO
  object
>("stores.salesInvoices.stats");

export const stats = {
  ...getApis,
};
